import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import type { ReactNode } from 'react'

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="wrap" style={{ paddingTop: 'var(--sp-8)' }}>
        <p className="muted" style={{ fontFamily: 'var(--mono)', letterSpacing: '.14em', fontSize: 13 }}>
          LOADING…
        </p>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />
  }

  return <>{children}</>
}
